import React, { useEffect, useState } from 'react';

const defaultValue = ''

const SearchBlock = ({label, forwardedRef, selectState, fetchdata, searchrecipe, placeholdertext}) => {

    const [btnstate, setBtnstate] = useState(false)
    const [resdata, setResdata] = useState(defaultValue)

    useEffect(() => {        
        forwardedRef.current.focus()
    },[])    

    const changeHandler = (event) => {
        let entereddata = event.target.value
        if(entereddata.length > 0){
            setBtnstate(true)
            selectState = true
            setResdata(entereddata);
        } else {
            setBtnstate(false)
            selectState = false
            setResdata(defaultValue);
        }
    }

    useEffect(() => {
        fetchdata(resdata,'bsearch')        
    }, [resdata])

    useEffect(() => {
        if(!selectState){
            setBtnstate(false)
            selectState = false
            setResdata(defaultValue);
        }
    },[selectState])

    return (
        <div className="searchblk">            
            <div className="searchfield">                
                <input 
                    type="text" 
                    ref={forwardedRef} 
                    onChange={(e) => changeHandler(e)}
                    value={resdata}
                    placeholder={placeholdertext}
                />
                <button 
                    disabled={!btnstate} 
                    type="submit"
                    onClick={searchrecipe}
                >
                    <i className="fa fa-search"></i>
                </button>
            </div>
        </div>
    );
};

export default SearchBlock;